<form class="wm-manual-website-test form" (ngSubmit)="confirm()">
    <div class="form-section">
        <div class="form-section-info">
            <h4>Website URL</h4>
            <div class="description">Enter the URL you want to test. It will be opened automatically in the browser after the device is deployed.</div>
        </div>
        <div class="form-section-content flex">
            <div class="form-item">
                <div class="form-label">URL</div>
                <div class="form-input">
                    <input pInputText type="url" placeholder="https://example.com" name="url" [(ngModel)]="url">
                </div>
            </div>
        </div>
    </div>
    <div class="wm-manual-website-test-controls">
        <button pButton type="submit" [disabled]="!isValidUrl">Next</button>
    </div>
</form>
